import {
  Box,
  Button,
  FormControl,
  FormLabel,
  HStack,
  Image,
  Input,
  Radio,
  RadioGroup,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { franchiseMapIndex } from "../../../core/constants";

function ComicForm({ handleSubmit, comic }) {
  const [title, setTitle] = useState(comic?.title ?? "");
  const [description, setDescription] = useState(comic?.description ?? "");
  const [franchise, setFranchise] = useState(
    comic?.franchise ? `${comic.franchise}` : ""
  );
  const [thumbnail, setThumbnail] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(comic?.thumbnail);

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setThumbnail(file);
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit({
      title,
      description,
      franchise,
      thumbnail,
    });
  };

  return (
    <form onSubmit={onSubmit}>
      <VStack spacing={4}>
        <FormControl id="title" isRequired>
          <FormLabel>Comic title</FormLabel>
          <Input
            name="title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            tabIndex={1}
          />
        </FormControl>
        <FormControl id="description">
          <FormLabel>Description</FormLabel>
          <Textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            tabIndex={2}
          />
        </FormControl>
        <FormControl id="thumbnail" mb={4}>
          <FormLabel>Cover Image</FormLabel>
          <Input
            type="file"
            accept="image/jpeg"
            onChange={handleFileInputChange}
            tabIndex={3}
          />
          {previewUrl && (
            <Box mt={2}>
              <Image src={previewUrl} alt="Preview" maxW="500px" maxH="500px" />
            </Box>
          )}
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Franchise</FormLabel>
          <RadioGroup
            value={franchise}
            onChange={(value) => setFranchise(value)}
          >
            <HStack spacing="24px">
              {Object.keys(franchiseMapIndex).map((franchise) => (
                <Radio key={franchise} value={franchise} tabIndex={4}>
                  {franchiseMapIndex[franchise]}
                </Radio>
              ))}
            </HStack>
          </RadioGroup>
        </FormControl>

        <Button type="submit" colorScheme="blue" tabIndex={7}>
          {comic ? "Update" : "Create"} comic
        </Button>
      </VStack>
    </form>
  );
}

export default ComicForm;
